import React from "react";

const StickyHeader = ({
  scrollToRef,
  userDetailsRef,
  medicationsRef,
  vitalsRef,
  symptomsRef,
  investigationsRef,
  active,
  setActive,
}) => {
  const handleTabClick = (refName) => {
    scrollToRef(refName);
    setActive(refName); // Update the active state when a tab is clicked
  };

  return (
    <div className="sticky top-[70px] z-20 bg-white border-b-2 border-indigo-600 p-2 flex justify-evenly w-full  gap-x-1">
      <button
        onClick={() => handleTabClick(userDetailsRef)}
        className={`px-4 py-3 rounded-md text-indigo-600  hover:bg-indigo-200 transition duration-300 flex-1 border-none ${
          active === userDetailsRef
            ? "text-indigo-600 bg-indigo-200"
            : " bg-transparent transition-transform hover:-translate-y-1 ease-in-out"
        }`}
      >
        Patient Details
      </button>
      <button
        onClick={() => handleTabClick(medicationsRef)}
        className={`px-4 py-3 rounded-md text-indigo-600  hover:bg-indigo-200 transition duration-300 flex-1 border-none ${
          active === medicationsRef
            ? "text-indigo-600 bg-indigo-200"
            : " bg-transparent transition-transform hover:-translate-y-1 ease-in-out"
        }`}
      >
        Medications
      </button>
      <button
        onClick={() => handleTabClick(vitalsRef)}
        className={`px-4 py-3 rounded-md text-indigo-600  hover:bg-indigo-200 transition duration-300 flex-1 border-none ${
          active === vitalsRef
            ? "text-indigo-600 bg-indigo-200"
            : " bg-transparent transition-transform hover:-translate-y-1 ease-in-out"
        }`}
      >
        Vitals
      </button>
      <button
        onClick={() => handleTabClick(symptomsRef)}
        className={`px-4 py-3 rounded-md text-indigo-600  hover:bg-indigo-200 transition duration-300 flex-1 border-none ${
          active === symptomsRef
            ? "text-indigo-600 bg-indigo-200"
            : " bg-transparent transition-transform hover:-translate-y-1 ease-in-out"
        }`}
      >
        Symptoms
      </button>
      <button
        onClick={() => handleTabClick(investigationsRef)}
        className={`px-4 py-3 rounded-md text-indigo-600  hover:bg-indigo-200 transition duration-300 flex-1 border-none ${
          active === investigationsRef
            ? "text-indigo-600 bg-indigo-200"
            : " bg-transparent transition-transform hover:-translate-y-1 ease-in-out"
        }`}
      >
        Lab Tests
      </button>
      {/* Add more buttons as needed */}
    </div>
  );
};

export default StickyHeader;
